// const API_BASE_URL = 'http://164.52.218.45:5000';
// const API_BASE_URL = "http://localhost:3000";
const API_BASE_URL = "https://app.spectrumpublication.in"

// Error handling utilities
interface ApiError {
  message: string;
  status?: number;
  details?: any;
}

const handleApiResponse = async (response: Response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw {
      message: errorData.message || 'An error occurred while processing your request',
      status: response.status,
      details: errorData
    } as ApiError;
  }
  return response.json();
};

const makeApiCall = async (url: string, options?: RequestInit) => {
  try {
    const response = await fetch(url, options);
    return await handleApiResponse(response);
  } catch (error) {
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      throw {
        message: 'Unable to connect to the server. Please check your internet connection.',
        status: 0
      } as ApiError;
    }
    throw error;
  }
};

// Simple API functions using fetch
export const api = {
  // Series
  getSeries: () => makeApiCall(`${API_BASE_URL}/series`),
  
  createSeries: (data: any) => makeApiCall(`${API_BASE_URL}/series`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),

  updateSeries: (id: number, data: any) => makeApiCall(`${API_BASE_URL}/series/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
  
  deleteSeries: (id: number) => makeApiCall(`${API_BASE_URL}/series/${id}`, {
    method: 'DELETE',
  }),

  // Subjects
  getSubjects: () => makeApiCall(`${API_BASE_URL}/subjects`),
  
  createSubject: (data: any) => makeApiCall(`${API_BASE_URL}/subjects`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),

  updateSubject: (id: number, data: any) => makeApiCall(`${API_BASE_URL}/subjects/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),

  deleteSubject: (id: number) => makeApiCall(`${API_BASE_URL}/subjects/${id}`, {
    method: 'DELETE',
  }),

  // Classes
  getClasses: () => makeApiCall(`${API_BASE_URL}/classes`),
  
  createClass: (data: any) => makeApiCall(`${API_BASE_URL}/classes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),

  updateClass: (id: number, data: any) => makeApiCall(`${API_BASE_URL}/classes/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),

  deleteClass: (id: number) => makeApiCall(`${API_BASE_URL}/classes/${id}`, {
    method: 'DELETE',
  }),

  // Books
  getBooks: () => makeApiCall(`${API_BASE_URL}/books`),
  
  createBook: (data: any) => makeApiCall(`${API_BASE_URL}/books`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),

  updateBook: (id: number, data: any) => makeApiCall(`${API_BASE_URL}/books/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),

  deleteBook: (id: number) => makeApiCall(`${API_BASE_URL}/books/${id}`, {
    method: 'DELETE',
  }),

  // Book Types
  getBookTypes: () => makeApiCall(`${API_BASE_URL}/book-types`),
  
  createBookType: (data: any) => makeApiCall(`${API_BASE_URL}/book-types`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),

  updateBookType: (id: number, data: any) => makeApiCall(`${API_BASE_URL}/book-types/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),

  deleteBookType: (id: number) => makeApiCall(`${API_BASE_URL}/book-types/${id}`, {
    method: 'DELETE',
  }),

  // Book Files
  getBookFiles: () => makeApiCall(`${API_BASE_URL}/book-files`),

  getBookFilesByBookId: (bookId: number) => makeApiCall(`${API_BASE_URL}/book-files/book/${bookId}`),

  getBookFilesByType: (typeId: number) => makeApiCall(`${API_BASE_URL}/book-files/type/${typeId}`),

  // File Upload
  uploadFile: (formData: FormData) => makeApiCall(`${API_BASE_URL}/book-files/upload`, {
    method: 'POST',
    body: formData,
  }),

  deleteBookFile: (id: number) => makeApiCall(`${API_BASE_URL}/book-files/${id}`, {
    method: 'DELETE',
  }),

  // App Metadata
  getMetadata: () => makeApiCall(`${API_BASE_URL}/mobile-apis/getMetadata`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  }),

  updateMetadata: (data: any) => makeApiCall(`${API_BASE_URL}/mobile-apis/editMetadata`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
}; 